var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaiseIssueSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.709,
    height: 160,
    viewBox: "0 0 201.709 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_boxes_confirm_ticket",
    transform: "translate(0 1.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38833",
    "data-name": "Path 38833",
    d: "M123.1,140.12l-5.358,4.914,4.248-7.135a55.337,55.337,0,0,0-8.829-11.327s-11.355,10.883-11.355,19.462,5.081,11.549,11.355,11.549,11.355-3,11.355-11.549A14.84,14.84,0,0,0,123.1,140.12Z",
    transform: "translate(0.722 1)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38834",
    "data-name": "Path 38834",
    d: "M116.382,145.311v.416c-.028,4.914-.861,8.718-2.471,11.438-.028.028-.056.083-.083.111l-.194-.111-.167-.111c1.8-2.915,2.443-7.024,2.471-11.3v-.416a50.143,50.143,0,0,0-.305-5.414,2.143,2.143,0,0,0-.056-.416c-.25-2.36-.611-4.581-.972-6.552l-.083-.416c-.639-3.3-1.277-5.691-1.416-6.219a.277.277,0,0,1-.028-.111l.194-.056h0l.194-.056s.028.139.083.361c.222.833.805,3.082,1.388,6.025l.083.416c.305,1.582.583,3.359.805,5.192.056.472.111.916.167,1.388.028.139.028.278.056.416C116.271,141.841,116.355,143.646,116.382,145.311Z",
    transform: "translate(0.723 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38835",
    "data-name": "Path 38835",
    d: "M114.966,132.513c-.139.028-.278.028-.416.056-.389.028-.777.056-1.166.056a11.379,11.379,0,0,1-4.859-1.083,2.942,2.942,0,0,1-.278.333,11.574,11.574,0,0,0,5.108,1.166c.416,0,.833-.028,1.249-.056.139-.028.278-.028.416-.056a11.554,11.554,0,0,0,3.332-1l-.25-.333A11.713,11.713,0,0,1,114.966,132.513Z",
    transform: "translate(0.717 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38836",
    "data-name": "Path 38836",
    d: "M116.021,139.509h-.583a11.261,11.261,0,0,1-9.245-4.831c-.083.111-.167.25-.25.361a11.7,11.7,0,0,0,9.495,4.886h.611a11.579,11.579,0,0,0,6.191-2.166c-.056-.111-.139-.25-.194-.361A11.352,11.352,0,0,1,116.021,139.509Z",
    transform: "translate(0.725 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38837",
    "data-name": "Path 38837",
    d: "M116.382,145.311c-.139,0-.305.028-.444.028h-.472a11.269,11.269,0,0,1-10.828-8.135c-.083.167-.194.333-.278.5a11.731,11.731,0,0,0,11.105,8.051h.472a2.388,2.388,0,0,0,.444-.028,11.763,11.763,0,0,0,7.718-3.748c-.056-.167-.083-.305-.139-.472A11.261,11.261,0,0,1,116.382,145.311Z",
    transform: "translate(0.728 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 27.43,
    cy: 27.43,
    r: 27.43,
    transform: "translate(0 0.833)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 22.849,
    cy: 22.849,
    r: 22.849,
    transform: "translate(4.581 5.414)",
    fill: "#4b4495"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 27.43,
    cy: 27.43,
    r: 27.43,
    transform: "translate(73.425 0.833)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 22.849,
    cy: 22.849,
    r: 22.849,
    transform: "translate(78.006 5.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 27.43,
    cy: 27.43,
    r: 27.43,
    transform: "translate(146.85 0.833)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 22.849,
    cy: 22.849,
    r: 22.849,
    transform: "translate(151.431 5.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38838",
    "data-name": "Path 38838",
    d: "M25.486,36.508h-.111a2.482,2.482,0,0,1-1.86-.972l-3.526-4.5a2.494,2.494,0,0,1,.444-3.526l.139-.111a2.494,2.494,0,0,1,3.526.444,2.245,2.245,0,0,0,3.137.389,1.8,1.8,0,0,0,.25-.222l7.107-7.524a2.506,2.506,0,0,1,3.554-.083h0l.111.111a2.506,2.506,0,0,1,.083,3.554l-11.05,11.66A2.5,2.5,0,0,1,25.486,36.508Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38839",
    "data-name": "Path 38839",
    d: "M88.2,22.71H70.157V7.024a3.662,3.662,0,0,1,3.72-3.609h6A8.2,8.2,0,0,1,88.2,11.438Z",
    transform: "translate(0.485)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38840",
    "data-name": "Path 38840",
    d: "M94.866,154.029H91.451l-1.638-13.215h5.053Z",
    transform: "translate(0.579 1)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38841",
    "data-name": "Path 38841",
    d: "M95.754,157.36H84.7v-.139a4.289,4.289,0,0,1,4.3-4.3h6.746Z",
    transform: "translate(0.564 1)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38842",
    "data-name": "Path 38842",
    d: "M63.3,154.029H59.857l-1.61-13.215H63.3Z",
    transform: "translate(0.376 1)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38843",
    "data-name": "Path 38843",
    d: "M64.16,157.36H53.111v-.139a4.289,4.289,0,0,1,4.3-4.3H64.16Z",
    transform: "translate(0.354 1)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38844",
    "data-name": "Path 38844",
    d: "M67.436,47.863l-2.249,14.27,21.239.278L83.65,48.724Z",
    transform: "translate(0.459 0.34)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38845",
    "data-name": "Path 38845",
    d: "M65.826,58.635,59.052,76.654l-.833,74.627h5.719L77.625,91.312,90.2,149.726h5.58L91.9,84.066s1.166-13.187-4.747-20.961L85.7,58.941Z",
    transform: "translate(0.451 1)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38846",
    "data-name": "Path 38846",
    d: "M94.838,72.683A4.2,4.2,0,0,1,91.9,67.547a2.954,2.954,0,0,1,.25-.694L83.122,37.4l6.635-1.3,8.273,28.873a4.2,4.2,0,0,1-3.193,7.718Z",
    transform: "translate(0.571 0.305)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38847",
    "data-name": "Path 38847",
    d: "M82.872,55.748,68.241,55.47a1.9,1.9,0,0,1-1.8-1.444,57.907,57.907,0,0,1-1.582-19.267A11.77,11.77,0,0,1,77.9,24.431a1.394,1.394,0,0,1,.333.056A11.738,11.738,0,0,1,88.2,37.813a11.372,11.372,0,0,1-.278,1.333c-1.832,7-2.887,11.994-3.082,14.881a1.889,1.889,0,0,1-1.527,1.721h0a1.583,1.583,0,0,1-.361.028A.215.215,0,0,0,82.872,55.748Z",
    transform: "translate(0.461 0.2)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38848",
    "data-name": "Path 38848",
    d: "M38.4,29.873a3.963,3.963,0,0,1,.222.611L56.942,36.7,60.5,33.621l5.358,4.72-5.747,6.08a3.122,3.122,0,0,1-3.692.639l-19.6-10.022a4.1,4.1,0,1,1,1.36-5.636,3.614,3.614,0,0,1,.222.472Z",
    transform: "translate(0.233 0.203)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38849",
    "data-name": "Path 38849",
    d: "M56.97,35.731A1.774,1.774,0,0,1,57.58,34.4L64.3,28.679a4.871,4.871,0,0,1,7.357,6.385l-4.775,7.44a1.752,1.752,0,0,1-2.415.527,1.207,1.207,0,0,1-.194-.167l-6.691-5.83A1.716,1.716,0,0,1,56.97,35.731Z",
    transform: "translate(0.389 0.198)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38850",
    "data-name": "Path 38850",
    d: "M82.706,44.865a1.8,1.8,0,0,1-.888-1.166L79.846,35.12A4.872,4.872,0,0,1,88.9,31.511l4.414,7.663a1.758,1.758,0,0,1-.639,2.388.831.831,0,0,1-.222.111L84.205,44.92A1.866,1.866,0,0,1,82.706,44.865Z",
    transform: "translate(0.538 0.208)",
    fill: "#48d1cc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.137,
    cy: 4.164,
    rx: 3.137,
    ry: 4.164,
    transform: "translate(81.445 4.547) rotate(-66.871)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 8.551,
    cy: 8.551,
    r: 8.551,
    transform: "translate(67.648 4.081)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38851",
    "data-name": "Path 38851",
    d: "M80.429,2.86H70.657A2.8,2.8,0,0,0,67.8,5.442a2.749,2.749,0,0,0,2.582,2.943h.194a2.784,2.784,0,0,1,2.776,2.776V22.544h15.27V11.022a8.181,8.181,0,0,0-8.19-8.162Z",
    transform: "translate(0.476)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38852",
    "data-name": "Path 38852",
    d: "M128.6,157.777H22.821a.278.278,0,1,1,0-.555H128.6a.278.278,0,1,1,0,.555Z",
    transform: "translate(0 1)",
    fill: "#cacaca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseIssueSuccess);
export default __webpack_public_path__ + "static/media/raise_issue_success.4f5b5444ae2bd28f84629fcc3db951df.svg";
export { ForwardRef as ReactComponent };